<template>
    <div>
        <div class="container" v-if="status == '1'">
            <div class="fixed-top">
                <div style="width: 90%; margin: 0px auto;">
                    <el-image :src="require('@/assets/images/logo.jpg')" style="height: 60px; width: 60px; float: left;"></el-image>
                    <div style="line-height: 60px; height: 60px; float: left; font-weight: bold;">XUS商城</div>
                    <div style="line-height: 60px; height: 60px; float: left; margin-left: 200px;">
                        <div style=" float: left; cursor:pointer" @click="goToIndex()">首页</div>
                        <div style=" float: left; margin-left: 40px; cursor:pointer" @click="goToProducts()">产品</div>
                        <div style=" float: left; margin-left: 40px; cursor:pointer" @click="flag = true">联系我们</div>
                        <div style=" float: left; margin-left: 40px; cursor:pointer" @click="getToDocumentation()">支持\服务
                        </div>
                        <div style=" float: left; margin-left: 40px; cursor:pointer" @click="getToConcerning()">关于XUS
                        </div>
                    </div>
                    <div style="float: right; line-height: 60px; height: 60px;" v-if="loginFlag == false">
                        <div style="float: right; cursor:pointer;" class="logindiv" @click="login">
                            立即注册
                        </div>
                        <div style="float: right; cursor:pointer; font-size: 13px; margin-right: 10px;" @click="login">
                            登录
                        </div>
                        <div style="float: right; cursor:pointer; font-size: 13px; margin-right: 10px;" @click="getXusDemo()">
                            演示示例
                        </div>
                    </div>
                    <div style="float: right; line-height: 60px; height: 60px;" v-else>
                        <div style="float: right; cursor:pointer;">
                            <el-popover placement="bottom" trigger="hover">
                                <div style=" cursor:pointer;" class="chanpin" @click="getToOrders()">我的产品</div>
                                <div style="border-bottom: 1px solid #999999; margin-top: 5px; margin-bottom: 5px;"></div>
                                <div style=" cursor:pointer;" class="chanpin" @click="outLogin()">退出登录</div>
                                <div slot="reference">
                                    <i class="el-icon-user">{{ userName }}</i>
                                </div>
                            </el-popover>
                        </div>
                        <div style="float: right; cursor:pointer; font-size: 13px; margin-right: 10px;" @click="getXusDemo()">
                            演示示例
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="status == '0'">
            <div class="fixed-top">
                <div style="width: 90%; margin: 0px auto;">
                    <el-image :src="require('@/assets/images/logo.jpg')" style="height: 60px; width: 60px; float: left;"></el-image>
                    <div style="line-height: 60px; height: 60px; float: left; font-weight: bold;">XUS商城</div>
                    <!-- <div style="line-height: 60px; height: 60px; float: left; margin-left: 200px;">
                        <div style=" float: left; cursor:pointer" @click="goToIndex()">首页</div>
                        <div style=" float: left; margin-left: 40px; cursor:pointer" @click="goToProducts()">产品</div>
                        <div style=" float: left; margin-left: 40px; cursor:pointer" @click="flag = true">联系我们</div>
                        <div style=" float: left; margin-left: 40px; cursor:pointer" @click="getToDocumentation()">支持\服务
                        </div>
                        <div style=" float: left; margin-left: 40px; cursor:pointer" @click="getToConcerning()">关于XUS
                        </div>
                    </div> -->
                    <div style="float: right; line-height: 60px; height: 60px;" v-if="loginFlag == false">
                        <div style="float: right; cursor:pointer;" class="logindiv" @click="login">
                            立即注册
                        </div>
                        <div style="float: right; cursor:pointer; font-size: 13px; margin-right: 10px;" @click="login">
                            登录
                        </div>
                        <div style="float: right; cursor:pointer; font-size: 13px; margin-right: 10px;" @click="getXusDemo()">
                            演示示例
                        </div>
                    </div>
                    <div style="float: right; line-height: 60px; height: 60px;" v-else>
                        <div style="float: right; margin-left: 10px;">
                            <i class="el-icon-s-operation" style="" @click="drawer = true"></i>
                        </div>
                        <div style="float: right; cursor:pointer;">
                            <el-popover placement="bottom" trigger="hover">
                                <div style=" cursor:pointer;" class="chanpin" @click="getToOrders()">我的产品</div>
                                <div style="border-bottom: 1px solid #999999; margin-top: 5px; margin-bottom: 5px;"></div>
                                <div style=" cursor:pointer;" class="chanpin" @click="outLogin()">退出登录</div>
                                <div slot="reference">
                                    <i class="el-icon-user"></i>
                                </div>
                            </el-popover>
                        </div>
                        <div style="float: right; cursor:pointer; font-size: 13px; margin-right: 10px;" @click="getXusDemo()">
                            演示示例
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 手机端标签栏 -->
        <el-drawer title="我是标题" direction='ltr' size="50%" :visible.sync="drawer" :with-header="false">
            <el-image :src="require('@/assets/images/logo.jpg')" style="height: 60px; width: 60px; float: left; margin-left: 20px;"></el-image>
            <div style="line-height: 60px; height: 60px; float: left; font-weight: bold;">XUS商城</div>
            <div style="margin-left: 20px;">
                <div style="width: 100%; margin-top: 70px;" @click="goToIndex()">首页</div>
                <el-divider></el-divider>
                <div style="width: 100%;" @click="goToProducts()">产品</div>
                <el-divider></el-divider>
                <div style="width: 100%;" @click="flag = true">联系我们</div>
                <el-divider></el-divider>
                <div style="width: 100%;" @click="getToDocumentation()">支持\服务</div>
                <el-divider></el-divider>
                <div style="width: 100%;" @click="getToConcerning()">关于XUS</div>
            </div>
        </el-drawer>
        <el-dialog title="联系方式" :visible.sync="flag" :width="status == '1' ? '30%' : '80%'">
            <span>13514269986</span><br>
            <span>联系方式2</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="flag = false">取 消</el-button>
                <el-button type="primary" @click="flag = false">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="系统演示" :visible.sync="demonstrate" :width="status == '1' ? '40%' : '80%'">
            <el-table :data="demoData" v-loading="loading">
                <el-table-column width="150">
                    XUS演示站
                </el-table-column><!--xus数字商城-->
                <el-table-column property="url" width="200">
                    <template slot-scope="scope">
                        <a :href="scope.row.url">{{ scope.row.demoName }}</a>
                    </template>
                </el-table-column>
                <el-table-column width="200">
                    <template slot-scope="scope">
                        <div>
                            账号：{{ scope.row.access }}<br />
                            密码：{{ scope.row.password }}
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button @click="demonstrate = false">取 消</el-button>
                <el-button type="primary" @click="demonstrate = false">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 我的账单 -->
        <el-dialog title="我的订单" :visible.sync="userOrderFlag" width="80%">
            <el-table :data="orderList" v-loading="loading">
                <el-table-column width="150" prop="xusVersion" label="版本">
                </el-table-column>
                <el-table-column width="150" prop="amount" label="金额">
                </el-table-column>
                <el-table-column width="200" prop="insertDate" label="购买时间">
                </el-table-column>
                <el-table-column property="ordersStatus" width="200" label="购买状态">
                    <template slot-scope="scope">
                        <el-tag type="success">购买成功</el-tag>
                    </template>
                </el-table-column>
                <el-table-column width="150" prop="url" label="绑定域名">
                </el-table-column>
                <el-table-column width="150" prop="userIp" label="绑定IP">
                </el-table-column>
                <el-table-column width="150" prop="jhm" label="激活码">
                    <template slot-scope="scope">
                        <el-button type="info" size="mini" :data-clipboard-text="scope.row.jhm" @click="copyJHM()" class="tag-copy">复制</el-button>
                    </template>
                </el-table-column>
                <el-table-column width="150" label="操作">
                    <template slot-scope="scope">
                        <el-button type="success" size="mini" @click="dowload(scope.row.id)">下载</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button @click="demonstrate = false">取 消</el-button>
                <el-button type="primary" @click="demonstrate = false">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>



<script>
    import clipboard from 'clipboard';

    export default {
        props: {
            loginFlag: {
                type: Boolean, // 数据类型
                required: false // 是否必传
            },
            userName: {
                type: String, // 数据类型
                required: false // 是否必传
            },
        },
        name: "top-bar",
        data() {
            return {
                // 标题栏是否弹出
                drawer: false,
                flag: false, //联系方式的参数
                demonstrate: false,
                demoData: [],
                // 加载提示
                loading: false,
                // 我的账单是否弹出
                userOrderFlag: false,
                getUserOrdersData: {
                    userId: '',
                    userTK: ''
                },
                // 订单列表
                orderList: [],
                status: sessionStorage.getItem('statusPC')
            };
        },
        methods: {
            // 跳转到登录
            login() {
                this.$router.push('/login')
            },
            // 跳转到首页
            goToIndex() {
                if (this.$route.path == '/') {
                    return
                }
                this.$router.push('/')
            },
            // 跳转到产品
            goToProducts() {
                if (this.$route.path == '/products') {
                    return
                }
                this.$router.push('/products');
            },
            // 关于我们
            getToConcerning() {
                if (this.$route.path == '/concerning') {
                    return
                }
                this.$router.push('/concerning')
            },
            // 技术支持
            getToDocumentation() {
                if (this.status != '1') {
                    this.$message.error('请使用电脑访问, 暂不支持手机')
                    return
                }
                if (this.$route.path == '/documentation') {
                    return
                }
                this.$router.push('/documentation')
            },
            // 查询演示站功能
            async getXusDemo() {
                this.loading = true
                this.demonstrate = true
                const res = await this.$api.post(this.$apiUrl.getXusDemoInfo, null)
                this.demoData = res.data.vo
                this.loading = false
            },
            // 退出登录功能
            outLogin() {
                this.loginFlag = false
                this.userName = ''
                localStorage.removeItem('userTK');
                localStorage.removeItem('userName')
                localStorage.removeItem('userId')
            },
            // 跳转到订单页面
            async getToOrders() {
                this.loading = true
                this.userOrderFlag = true
                this.getUserOrdersData.userId = localStorage.getItem("userId")
                this.getUserOrdersData.userTK = localStorage.getItem("userTK")
                const res = await this.$api.post(this.$apiUrl.getUserOrders, this.getUserOrdersData)
                this.orderList = res.data.list
                this.loading = false
            },
            // 复制激活码功能
            copyJHM() {
                let clipboard = new this.clipboard(".tag-copy");
                clipboard.on("success", (e) => {
                    this.$message({
                        message: "激活码复制成功!",
                        type: "success",
                        duration: 2000,
                    });
                    //清除选中
                    e.clearSelection();
                    //释放内存，以防重复复制
                    clipboard.destroy();
                });
                clipboard.on("error", (e) => {
                    // 不支持复制
                    this.$message({
                        message: "激活码复制失败!",
                        type: "error",
                        duration: 2000,
                    });
                    //清除选中
                    e.clearSelection();
                    //释放内存，以防重复复制
                    clipboard.destroy();
                });
            },
            // 下载功能
            async dowload(orderId) {
                if (this.status != '1') {
                    this.$message.error('请使用电脑下载, 暂不支持手机')
                    return
                }
                var dowloadData = {
                    orderId: orderId,
                    userId: localStorage.getItem('userId'),
                    userTK: localStorage.getItem('userTK')
                }
                const res = await this.$api.post(this.$apiUrl.download, dowloadData)
                console.log(res)
            }
        }
    };
</script>

<style>
    .container {
        width: 95%;
        height: 60px;
        -webkit-user-select: none;
        /* Safari */
        -moz-user-select: none;
        /* Firefox */
        -ms-user-select: none;
        /* IE 10+ */
        user-select: none;
        /* 标准语法 */
    }

    .fixed-top {
        position: fixed;
        top: 0;
        width: 100%;
        background-color: #ffffff;
        z-index: 999;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }


    /* 立即注册按钮 */
    .logindiv {
        background-color: #0055ff;
        height: 35px;
        line-height: 35px;
        margin-top: 12px;
        border-radius: 20px;
        padding-left: 10px;
        padding-right: 10px;
        color: #ffffff;
    }

    /* 设置超链接样式 */
    a {
        text-decoration: none;
        /* 去除默认的下划线 */
        outline: none;
        /* 去除旧版浏览器的点击后的外虚线框 */
        color: #0055ff;
        /* 去除默认的颜色和点击后变化的颜色 */

    }

    /* 产品样式 */
    .chanpin {
        -webkit-user-select: none;
        /* Safari */
        -moz-user-select: none;
        /* Firefox */
        -ms-user-select: none;
        /* IE 10+ */
        user-select: none;
        /* 标准语法 */
    }
</style>